import { render, staticRenderFns } from "./EditAgent.vue?vue&type=template&id=77ae21e7&"
import script from "./EditAgent.vue?vue&type=script&lang=ts&"
export * from "./EditAgent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports